import { Navigate, Outlet } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"

const RouteGuard = ({ allow }) => {
  const { auth, isLogin, isChecking } = useAuth()

  // 認証チェック中は何も描画しない
  if (isChecking) {
    return null
  }

  // ログインしていない場合はログイン画面へ遷移
  if (!isLogin) {
    return <Navigate to="/" replace />
  }

  const authValue = Number(auth)

  if (!allow.includes(authValue)) {
    // 権限なしの場合、ログイン画面に遷移する
    return <Navigate to="/" replace />
  }

  return <Outlet />
}

export default RouteGuard